import { Box, Dialog, LinearProgress, Button, DialogContent } from '@mui/material'
import { CancelOutlined } from '@mui/icons-material'
import { Pagination } from '@mui/material'

const FilePreview = ({
  images,
  currentPage,
  previewLoading,
  isDialogOpen,
  onPageChange,
  onCloseDialog,
}) => {
  const itemsPerPage = 1
  const totalPages = Math.ceil(images.length / itemsPerPage)

  return (
    <Dialog open={isDialogOpen} onClose={onCloseDialog} maxWidth="xxl">
      <Box sx={{ width: '100%' }}>
        {previewLoading ? (
          <Box
            sx={{
              width: '100%',
              minWidth: 600,
              maxWidth: 800,
              padding: '20px',
            }}
          >
            <LinearProgress color="primary" />
          </Box>
        ) : (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              minHeight: '100vh',
              position: 'relative',
            }}
          >
            <DialogContent sx={{ flex: '1 1 auto', width: '100%' }}>
              {images.length === 0 ? (
                <div>Preview not available. Click the "Download" icon to download file</div>
              ) : (
                <div style={{ position: 'relative', textAlign: 'center' }}>
                  {images && (
                    <img
                      style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                      src={images[currentPage - 1]}
                      alt="File Preview"
                    />
                  )}
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                    }}
                  >
                    <Button color="info" size="small" onClick={onCloseDialog}>
                      <CancelOutlined size="small" />
                    </Button>
                  </div>
                </div>
              )}
            </DialogContent>
            {images && (
              <Box
                sx={{
                  maxWidth: '800px',
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '10px',
                  backgroundColor: 'white',
                  position: 'fixed',
                  bottom: '5%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}
              >
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={onPageChange}
                  variant="outlined"
                  shape="rounded"
                />
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Dialog>
  )
}

export default FilePreview
